import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';
var formatListNumberedRTL = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, createElement(Path, {
  d: "M20 8.75H4V7.25H20V8.75ZM12.8889 15.75H4V14.25H12.8889V15.75ZM20 13V12.3063L19.3419 12.5257L17.8419 13.0257L18.1581 13.9743L19 13.6937V17H20V13Z"
}));
export default formatListNumberedRTL;
//# sourceMappingURL=format-list-numbered-rtl.js.map